var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getResources } from 'app/store/selectors/getResources';
import { filter, values, isEqual } from 'lodash';
import { MUIModal } from 'app/components/Modal';
import DashboardWidgets from 'app/pages/Project/ProductionManagement/Dashboards/DashboardWidgets/DashboardWidgets';
import { widgetsByDashboardSelector } from 'app/store/selectors/widgets';
import { fetchDashboardData, fetchOneDashboard, updateDashboard } from 'app/store/reducers/dashboards';
import { selectedDashboardSelector } from 'app/store/selectors/dashboards';
import resources from 'app/store/resources';
import { WIDGET_TYPES } from 'app/pages/Project/ProductionManagement/Dashboards/constants';
import Loader from 'app/components/Loader/Loader.jsx';
import { success } from 'app/components/Notifications/notify';
const ModalEditDashboardLayout = (_a) => {
    var { projectId, dashboardId } = _a, modalprops = __rest(_a, ["projectId", "dashboardId"]);
    const dispatch = useDispatch();
    const activeDashboard = useSelector(selectedDashboardSelector(dashboardId));
    const allEpisodes = useSelector((state) => filter(state.assets.resources, (asset) => asset.assetType === 'ep'));
    const widgets = useSelector(widgetsByDashboardSelector(dashboardId));
    const stepProjects = getResources(undefined, 'steps');
    const progressionStatus = getResources(undefined, 'progressionStatus');
    const [loading, setLoading] = useState(true);
    const [dashboardLayout, setDashboardLayout] = useState([]);
    const [activeEpisodesByWidget, setActiveEpisodesByWidget] = useState([]);
    const saveLayoutInDB = () => __awaiter(void 0, void 0, void 0, function* () {
        const updatedDashboard = Object.assign(Object.assign({}, activeDashboard), { config: Object.assign(Object.assign({}, activeDashboard.config), { layout: dashboardLayout }) });
        yield dispatch(updateDashboard(updatedDashboard));
        success('Layout saved');
    });
    const saveDashboardLayoutsInLS = (updatedLayout) => {
        let dashboardsLs = {};
        const localStorageDashboardsData = localStorage.getItem('dashboardLayouts');
        if (localStorageDashboardsData) {
            dashboardsLs = JSON.parse(localStorageDashboardsData);
        }
        const updatedLsDashboards = Object.assign(Object.assign({}, dashboardsLs), { [projectId]: updatedLayout });
        localStorage.setItem('dashboardLayouts', JSON.stringify(updatedLsDashboards));
    };
    const saveDashboardLayoutLocally = (newLayouts) => {
        setDashboardLayout((prevState) => {
            const updatedLayout = prevState.map((layout) => {
                const el = newLayouts.find((nl) => nl.i === layout.i);
                if (el) {
                    return Object.assign(Object.assign({}, layout), { h: el.h, w: el.w, x: el.x, y: el.y });
                }
                return layout;
            });
            saveDashboardLayoutsInLS(updatedLayout);
            return updatedLayout;
        });
    };
    const generateLayouts = (widgets) => {
        const layouts = widgets.map((widget) => {
            var _a, _b;
            const dashboardsLs = localStorage.getItem('dashboardLayouts');
            if (dashboardsLs) {
                const lsLayout = ((_a = JSON.parse(dashboardsLs)) === null || _a === void 0 ? void 0 : _a[projectId]) || [];
                const lsWidgetLayout = lsLayout.find((lay) => lay.i === widget.id);
                if (lsWidgetLayout) {
                    return lsWidgetLayout;
                }
            }
            const savedWidgetLayout = (_b = activeDashboard.config.layout) === null || _b === void 0 ? void 0 : _b.find((lay) => lay.i === widget.id);
            if (savedWidgetLayout) {
                return savedWidgetLayout;
            }
            if (widget.widgetType === WIDGET_TYPES.CONTAINER) {
                return {
                    w: 6,
                    h: 22,
                    x: 0,
                    y: 0,
                    i: widget.id,
                    name: widget.name,
                    moved: false,
                    static: false,
                };
            }
            return {
                w: 6,
                h: 10,
                x: 0,
                y: 0,
                i: widget.id,
                name: widget.name,
                moved: false,
                static: false,
            };
        });
        return layouts;
    };
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(true);
            const promises = [
                dispatch(fetchOneDashboard(dashboardId)),
                dispatch(fetchDashboardData(activeDashboard.id)),
                !allEpisodes.length && resources.assets.fetchEpisodes(projectId),
                !values(stepProjects).length && resources.steps.fetchByProject(projectId),
            ];
            yield Promise.all(promises);
            setLoading(false);
        }))();
    }, []);
    useEffect(() => {
        if (!loading) {
            const generatedLayouts = generateLayouts(widgets);
            const actEpisodes = widgets.map((widget) => {
                var _a;
                return {
                    widgetId: widget.id,
                    episodes: (_a = widget.config.episodes) !== null && _a !== void 0 ? _a : [],
                };
            });
            setActiveEpisodesByWidget(actEpisodes);
            setDashboardLayout(generatedLayouts);
        }
    }, [loading]);
    return (_jsx(MUIModal, Object.assign({ title: "Dashboard layout", validateLabel: "Save", loading: loading, disableValidate: isEqual(dashboardLayout, activeDashboard === null || activeDashboard === void 0 ? void 0 : activeDashboard.config.layout) ||
            (!dashboardLayout.length && !(activeDashboard === null || activeDashboard === void 0 ? void 0 : activeDashboard.config.layout)), onValidate: saveLayoutInDB, resizable: false, width: "100vw", minHeight: "100vh", childreContainerStyle: {
            minHeight: '80vh',
            display: loading ? 'flex' : 'initial',
            justifyContent: loading ? 'center' : 'initial',
            alignItems: loading ? 'center' : 'initial',
        } }, modalprops, { children: loading ? (_jsx(Loader, {})) : (_jsx(DashboardWidgets, { allEpisodes: allEpisodes, allLayouts: dashboardLayout, widgets: widgets, stepProjects: stepProjects, dashboardLayout: dashboardLayout, setDashboardLayout: setDashboardLayout, progressionStatus: progressionStatus, nested: false, activeEpisodesByWidget: activeEpisodesByWidget, setActiveEpisodesByWidget: setActiveEpisodesByWidget, saveDashboardLayoutLocally: saveDashboardLayoutLocally })) })));
};
export default ModalEditDashboardLayout;
